import OverviewVM from './overview-vm';
export default {
  prepUI: function() {
    //TODO
    console.log('Kadenze.InstructorGradebook.Overview.prepUI' );
  },
  init: function() {
    ko.applyBindingsWithValidation(new OverviewVM(), document.getElementById('gradebook_overview'), Kadenze.Knockout.DEFAULT_VALIDATION_OPTIONS);
  }
};
